import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../BaseModule/Components/BaseModal/BaseModal';
import UserWalletDeposit from './UserWalletDeposit';

const UserWalletDepositModal: React.FC<BaseModalProps> = props => (
	<BaseModal {...props} title='component.userWalletDeposit.modalTitle'>
		<UserWalletDeposit />
	</BaseModal>
);
export default UserWalletDepositModal;
